import React from 'react';

import './Footer.css';


export function Footer() {
  return (
    <footer className="footer wrapper">
      <p><small>&copy; Yukito Aomi</small></p>
    </footer>
  );
}
